import { useCallback } from "react";
import {
  getApiUrl,
  getEnvVar,
  useAppSearchParams,
  useLocalStorage,
  postMessageFn,
  StoreMetadata,
  isServer,
} from "../";

export type EventProps = {
  key: string;
  payload?: { [key: string]: string | undefined | null };
  ownerId?: string;
  providers?: string[];
};

export const createSumerEvent = async (
  key: string,
  payload?: { [key: string]: string | undefined },
  ownerId?: string,
  providers?: string[],
) => {
  const request = {
    owner_id: ownerId,
    event_type: key,
    information: payload,
    providers: providers || ["clevertap"],
  };

  return fetch(`${getApiUrl()}/api/ms/statistics/event/growth`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "api-key-sumer": getEnvVar("PUBLIC_API_KEY_SP"),
    } as { [key: string]: string },
    body: JSON.stringify(request),
  })
    .then((response) => {
      if (response.ok) return response.json();
      else throw Error(response.statusText);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const useAnalytics = ({
  storeMetadata,
}: {
  storeMetadata: StoreMetadata;
}) => {
  const [searchParams] = useAppSearchParams();
  const utmOriginParam = searchParams.get("utm_o");
  const STORAGE_KEY = "updates_count";
  const [updatesCount, setUpdatesCount] = useLocalStorage(STORAGE_KEY, 0);

  const logPersonalizationUpdatesToMobile = () => {
    if (updatesCount < 5) {
      setUpdatesCount((s) => {
        const newValue = s + 1;
        if (newValue === 3) {
          postMessageFn(`event:save_personalization_3_changes`);
        } else if (newValue === 4) {
          postMessageFn(`event:save_personalization_4_changes`);
        }
        return newValue;
      });
    } else {
      return;
    }
  };

  const logEventFn = useCallback(
    (
      key: string,
      payload?: { [key: string]: string | null },
      providers?: string[],
    ) => {
      const env = getEnvVar("PUBLIC_ENV");
      const eventName = env === "dev" ? `dev_${key}` : key;
      const isPersonalizationUpdate =
        key?.includes("personalization_apply") ||
        key === "select_save_configuration";

      if (!isServer) {
        const newPayload = {
          ...payload,
          user_id: "",
          owner_id: storeMetadata?.ownerId,
          city: storeMetadata?.city,
          country: storeMetadata?.country,
          bussines_name: storeMetadata?.enterpriseName,
          utm_source: utmOriginParam,
        };
        if (isPersonalizationUpdate) logPersonalizationUpdatesToMobile();
        createSumerEvent(
          eventName,
          newPayload as any,
          storeMetadata?.ownerId || "",
          providers,
        );
      }

      return { key, payload, providers } as EventProps;
    },
    [storeMetadata],
  );

  return [logEventFn];
};
